import api from './client';

// Per-user Google Drive connection + storage. All act on the signed-in user.
export const getDriveStatus  = ()            => api.get('/drive/status');
export const connectDrive    = ()            => api.get('/drive/connect');
export const disconnectDrive = ()            => api.post('/drive/disconnect');
export const getStorageStats = ()            => api.get('/images/storage-stats');
export const migrateToDrive  = (limit = 10)  => api.post('/images/migrate-to-drive', { limit });
